import type { LayoutProps } from '../../types';
import Footer from './Footer';

const Layout = ({ children, className = '' }: LayoutProps) => {
  return (
    <div className={`text-gray-300 antialiased ${className}`}>
      {children}
      
      {/* Footer */}
      <div className="bg-surface">
        <div className="container-2xl max-w-7xl mx-auto px-4 xl:px-8 pt-8 pb-16">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout; 